// actions suffix

export const START = '_START';
export const SUCCESS = '_SUCCESS';
export const FAIL = '_FAIL';
